import { render, staticRenderFns } from "./StepDelivery.vue?vue&type=template&id=aaa662ce&"
import script from "./StepDelivery.vue?vue&type=script&lang=js&"
export * from "./StepDelivery.vue?vue&type=script&lang=js&"
import style0 from "./StepDelivery.vue?vue&type=style&index=0&id=aaa662ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContinueMyShopping: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ContinueMyShopping.vue').default,MiniCart: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/MiniCart.vue').default})
